module.exports = "/_next/static/images/886add7a8f4c7d54944e2668a42d58b3-nucommunity-md@1x.jpg.webp";